// extracted by mini-css-extract-plugin
export default {"header":"DropColumnHeader_header__bPlZa","menuWrap":"DropColumnHeader_menuWrap__+B8cd"};